export default {
  mounted: function(){
    window.addEventListener('resize', this.resize);
  },
  data: ()=>({
    height: window.innerHeight,
    width: window.innerWidth,
  }),
  methods: {
    resize: function(){
      this.height = window.innerHeight;
      this.width = window.innerWidth;
    },
  }
}